import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Initialize Sentry (only if DSN is configured)
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 0.3,
  });
}

// Error boundary wrapper
const AppWithErrorBoundary = SENTRY_DSN
  ? Sentry.withErrorBoundary(App, {
      fallback: ({ error }) => (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#08090d', color: '#fff', fontFamily: 'Poppins, sans-serif', padding: '2rem', textAlign: 'center' }}>
          <div>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h1 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>Oops! Sesuatu tidak kena</h1>
            <p style={{ fontSize: '14px', color: '#94a3b8', marginBottom: '24px' }}>Kami telah dimaklumkan dan sedang memperbaikinya.</p>
            <button onClick={() => window.location.reload()} style={{ padding: '12px 32px', background: '#f59e0b', color: '#0f172a', border: 'none', borderRadius: '12px', fontWeight: 700, cursor: 'pointer', fontSize: '14px' }}>
              Muat Semula
            </button>
          </div>
        </div>
      ),
    })
  : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithErrorBoundary />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => console.log('SW registered:', reg.scope))
      .catch((err) => console.log('SW registration failed:', err));
  });
}
